'use strict';

import { Entity } from '../Entity';
import { GlobSunfireOrgCollection } from '../../Collections/Glob/GlobSunfireOrgCollection';

export class GlobSunfireOrg extends Entity {
  protected id;
  protected orgName;
  protected partnerId;
  protected app;
  protected appId;
  protected reference;
  protected canPost;
  protected canIngest;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.orgName = data.orgName;
    this.partnerId = data.partnerId;
    this.app = data.app;
    this.appId = data.appId;
    this.reference = data.reference;
    this.canPost = data.canPost;
    this.canIngest = data.canIngest;
  }

  public getId() {
    return this.id;
  }

  public getOrgName() {
    return this.orgName;
  }

  public getPartnerId() {
    return this.partnerId;
  }

  public getApp() {
    return this.app;
  }

  public getAppId() {
    return this.appId;
  }

  public getReference() {
    return this.reference;
  }

  public getCanPost() {
    return this.canPost;
  }

  public getCanIngest() {
    return this.canIngest;
  }
}
